import React, { useCallback } from 'react';
import styled from 'styled-components';
import TrueImpactText from 'shared/design-system/base/TrueImpactText';
import { IndicatorSectionKey, IndicatorWithUpdate } from '../utils';
import { COLORS } from 'shared/design-system/settings/variables/Colors';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRotateLeft } from '@fortawesome/pro-light-svg-icons';
import { SPACERS } from 'shared/design-system/settings/variables/Spacers';

interface RestoreIndicatorProps {
  index: number;
  sectionKey: IndicatorSectionKey;
  indicator: IndicatorWithUpdate;
  handleRestoreIndicator: (
    sectionKey: IndicatorSectionKey,
    indicator: IndicatorWithUpdate,
    index: number,
  ) => unknown;
}

const StyledDiv = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: ${SPACERS.small};
  margin-top: ${SPACERS.tiny};
  margin-bottom: ${SPACERS.tiny};
  background-color: ${COLORS.grayLightest};
  border-bottom: 1px solid ${COLORS.grayLight};
  .left {
    text-align: left;
  }
  .restore-indicator {
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    gap: ${SPACERS.extraTiny};
  }
`;

const RestoreIndicator: React.FC<RestoreIndicatorProps> = ({
  index,
  indicator,
  sectionKey,
  handleRestoreIndicator,
}) => {
  const handleRestore = useCallback(() => {
    handleRestoreIndicator(sectionKey, indicator, index);
  }, [sectionKey, indicator, index, handleRestoreIndicator]);
  return (
    <StyledDiv>
      <TrueImpactText className="left">
        <strong>Deleted indicator:</strong> {indicator.name}
      </TrueImpactText>
      <TrueImpactText onClick={handleRestore} className="restore-indicator">
        <FontAwesomeIcon color={COLORS.ctaPrimary} icon={faArrowRotateLeft} />{' '}
        Restore
      </TrueImpactText>
    </StyledDiv>
  );
};

export default RestoreIndicator;
